import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { useCurrentProduct } from "../useCurrentProduct";
import { designControlsApi } from "../../api/designControls";

type DesignElement = {
  id: string;
  code: string;
  title: string;
};

export const useDeleteTestCase = () => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (element: DesignElement) =>
      designControlsApi.deleteTestCaseById(companyId, productId, element.id),
    onSuccess: async (_: unknown, element: DesignElement) => {
      showToast({
        title: t("testCases.notifications.deleteSuccess.title"),
        description: t("testCases.notifications.deleteSuccess.description", {
          code: element.code,
          title: element.title,
        }),
        status: "success",
      });
      await queryClient.invalidateQueries([
        "OPEN_ISSUE_LIST",
        companyId,
        productId,
      ]);
    },
    onError: (_: unknown, element: DesignElement) => {
      showToast({
        title: t("testCases.notifications.deleteError.title"),
        description: t("testCases.notifications.deleteError.description", {
          code: element.code,
          title: element.title,
        }),
        status: "error",
      });
    },
  });
};
